import type { ErrorInfo, ReactNode } from 'react';
import { ErrorBoundary, type ErrorBoundaryProps } from 'react-error-boundary';
import { useSentry } from '@repo/runtime-kit/sentry/context';
import { shouldSendToSentry } from '@repo/runtime-kit/utils/should-send-to-sentry';

export { QontoErrorBoundary as ErrorBoundary };

export type QontoErrorBoundaryProps = ErrorBoundaryProps & {
  /**
   * HTTP status codes this boundary already handles as expected outcomes (e.g. a 404
   * redirect via its own `onError`), so they shouldn't also be reported to Sentry.
   */
  ignoreStatuses?: readonly number[];
};

export function QontoErrorBoundary({
  ignoreStatuses,
  ...props
}: QontoErrorBoundaryProps): ReactNode {
  const sentry = useSentry();

  const onError = (error: unknown, info: ErrorInfo): void => {
    if (shouldSendToSentry(error, { ignoreStatuses })) {
      sentry.captureException(error);
    }
    props.onError?.(error, info);
  };

  return <ErrorBoundary {...props} onError={onError} />;
}
